<template>
  <div>
    <slotBase :bg-grey="true" :footer-radius="false" :loading="loading">
      <template v-slot:title>
        <titleBar :header-title="'Ilham'" @back="back" />
      </template>
      <template v-slot:dropdown></template>
      <template v-slot:content>
        {{ dataLayanan }}
        <button @click="ubahstate">ubah state</button>
        <button type="button" class="btn btn-primary" @click="modalOpen">
          Launch demo modal
        </button>
      </template>
      <template v-slot:footer>
        <div class="d-flex justify-content-around">
          <div class="d-flex flex-column">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              class="m-auto"
            >
              <path
                d="M21.5503 13.0128H19.709V19.6205C19.709 20.1105 19.4953 20.7217 18.6077 20.7217H14.2026V14.1141H9.79751V20.7217H5.3924C4.50477 20.7217 4.29113 20.1105 4.29113 19.6205V13.0128H2.44979C1.79123 13.0128 1.93219 12.656 2.38372 12.189L11.2204 3.3436C11.4351 3.12114 11.717 3.01101 12.0001 3C12.2831 3.01101 12.565 3.12004 12.7798 3.3436L21.6153 12.1879C22.0679 12.656 22.2089 13.0128 21.5503 13.0128Z"
                fill="#6F7287"
              />
            </svg>
            <p class="f-Overpass f-12 f-w-400">Beranda</p>
          </div>
          <div class="d-flex flex-column">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              class="m-auto"
            >
              <path
                d="M21.4108 5.70199C20.1986 5.19356 18.9855 5.00012 17.773 5.00012C13.924 4.99981 10.0753 6.94822 6.22634 6.94822C5.26105 6.94822 4.29637 6.82572 3.33108 6.51947C3.22264 6.4851 3.11389 6.46885 3.00764 6.46885C2.46984 6.46885 1.99985 6.88509 1.99985 7.4629V17.3771C1.99985 17.7718 2.22578 18.1459 2.58859 18.2977C3.80076 18.8065 5.01386 18.9999 6.22634 18.9999C10.0753 18.9999 13.9244 17.0515 17.7734 17.0515C18.7387 17.0515 19.7033 17.174 20.6686 17.4802C20.7771 17.5146 20.8858 17.5309 20.9921 17.5309C21.5299 17.5309 21.9999 17.1146 21.9999 16.5368V6.62291C21.9995 6.22792 21.7736 5.85417 21.4108 5.70199ZM3.49982 8.13195C4.12856 8.28945 4.7848 8.36851 5.45979 8.41101C5.27605 9.32943 4.46856 10.0216 3.49982 10.0216V8.13195ZM3.49982 17.0381V15.545C4.57387 15.545 5.44292 16.3971 5.49073 17.4637C4.78668 17.4071 4.12856 17.2665 3.49982 17.0381ZM11.9997 15C10.6188 15 9.49973 13.6566 9.49973 12C9.49973 10.3432 10.6191 9.00006 11.9997 9.00006C13.3803 9.00006 14.4997 10.3432 14.4997 12C14.4997 13.6572 13.38 15 11.9997 15ZM20.4996 15.8681C19.9521 15.7309 19.3836 15.654 18.8021 15.6043C18.9855 14.7893 19.6614 14.1706 20.4996 14.0644V15.8681ZM20.4996 8.48976C19.5343 8.36757 18.7852 7.56165 18.7555 6.56635C19.3661 6.63416 19.9458 6.76103 20.4996 6.96197V8.48976Z"
                fill="#206CFE"
              />
            </svg>
            <p class="f-Overpass f-12 f-w-400">Top Up</p>
          </div>
          <div
            style="
              display: flex;
              width: 56px;
              height: 56px;
              padding: 8px;
              justify-content: center;
              align-items: center;
              gap: 10px;
              flex-shrink: 0;
              border-radius: 36px;
              background: var(--primary-product-smartlink, #206cfe);

              /* tooltips */
              box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
            "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M2.25 1.5C2.05109 1.5 1.86032 1.57902 1.71967 1.71967C1.57902 1.86032 1.5 2.05109 1.5 2.25V6.75C1.5 6.94891 1.42098 7.13968 1.28033 7.28033C1.13968 7.42098 0.948912 7.5 0.75 7.5C0.551088 7.5 0.360322 7.42098 0.21967 7.28033C0.0790176 7.13968 0 6.94891 0 6.75V2.25C0 1.65326 0.237053 1.08097 0.65901 0.65901C1.08097 0.237053 1.65326 0 2.25 0L6.75 0C6.94891 0 7.13968 0.0790176 7.28033 0.21967C7.42098 0.360322 7.5 0.551088 7.5 0.75C7.5 0.948912 7.42098 1.13968 7.28033 1.28033C7.13968 1.42098 6.94891 1.5 6.75 1.5H2.25ZM16.5 0.75C16.5 0.551088 16.579 0.360322 16.7197 0.21967C16.8603 0.0790176 17.0511 0 17.25 0L21.75 0C22.3467 0 22.919 0.237053 23.341 0.65901C23.7629 1.08097 24 1.65326 24 2.25V6.75C24 6.94891 23.921 7.13968 23.7803 7.28033C23.6397 7.42098 23.4489 7.5 23.25 7.5C23.0511 7.5 22.8603 7.42098 22.7197 7.28033C22.579 7.13968 22.5 6.94891 22.5 6.75V2.25C22.5 2.05109 22.421 1.86032 22.2803 1.71967C22.1397 1.57902 21.9489 1.5 21.75 1.5H17.25C17.0511 1.5 16.8603 1.42098 16.7197 1.28033C16.579 1.13968 16.5 0.948912 16.5 0.75ZM0.75 16.5C0.948912 16.5 1.13968 16.579 1.28033 16.7197C1.42098 16.8603 1.5 17.0511 1.5 17.25V21.75C1.5 21.9489 1.57902 22.1397 1.71967 22.2803C1.86032 22.421 2.05109 22.5 2.25 22.5H6.75C6.94891 22.5 7.13968 22.579 7.28033 22.7197C7.42098 22.8603 7.5 23.0511 7.5 23.25C7.5 23.4489 7.42098 23.6397 7.28033 23.7803C7.13968 23.921 6.94891 24 6.75 24H2.25C1.65326 24 1.08097 23.7629 0.65901 23.341C0.237053 22.919 0 22.3467 0 21.75L0 17.25C0 17.0511 0.0790176 16.8603 0.21967 16.7197C0.360322 16.579 0.551088 16.5 0.75 16.5ZM23.25 16.5C23.4489 16.5 23.6397 16.579 23.7803 16.7197C23.921 16.8603 24 17.0511 24 17.25V21.75C24 22.3467 23.7629 22.919 23.341 23.341C22.919 23.7629 22.3467 24 21.75 24H17.25C17.0511 24 16.8603 23.921 16.7197 23.7803C16.579 23.6397 16.5 23.4489 16.5 23.25C16.5 23.0511 16.579 22.8603 16.7197 22.7197C16.8603 22.579 17.0511 22.5 17.25 22.5H21.75C21.9489 22.5 22.1397 22.421 22.2803 22.2803C22.421 22.1397 22.5 21.9489 22.5 21.75V17.25C22.5 17.0511 22.579 16.8603 22.7197 16.7197C22.8603 16.579 23.0511 16.5 23.25 16.5ZM4.5 6.75C4.5 6.55109 4.57902 6.36032 4.71967 6.21967C4.86032 6.07902 5.05109 6 5.25 6C5.44891 6 5.63968 6.07902 5.78033 6.21967C5.92098 6.36032 6 6.55109 6 6.75V17.25C6 17.4489 5.92098 17.6397 5.78033 17.7803C5.63968 17.921 5.44891 18 5.25 18C5.05109 18 4.86032 17.921 4.71967 17.7803C4.57902 17.6397 4.5 17.4489 4.5 17.25V6.75ZM7.5 6.75C7.5 6.55109 7.57902 6.36032 7.71967 6.21967C7.86032 6.07902 8.05109 6 8.25 6C8.44891 6 8.63968 6.07902 8.78033 6.21967C8.92098 6.36032 9 6.55109 9 6.75V17.25C9 17.4489 8.92098 17.6397 8.78033 17.7803C8.63968 17.921 8.44891 18 8.25 18C8.05109 18 7.86032 17.921 7.71967 17.7803C7.57902 17.6397 7.5 17.4489 7.5 17.25V6.75ZM10.5 6.75C10.5 6.55109 10.579 6.36032 10.7197 6.21967C10.8603 6.07902 11.0511 6 11.25 6C11.4489 6 11.6397 6.07902 11.7803 6.21967C11.921 6.36032 12 6.55109 12 6.75V17.25C12 17.4489 11.921 17.6397 11.7803 17.7803C11.6397 17.921 11.4489 18 11.25 18C11.0511 18 10.8603 17.921 10.7197 17.7803C10.579 17.6397 10.5 17.4489 10.5 17.25V6.75ZM13.5 6.75C13.5 6.55109 13.579 6.36032 13.7197 6.21967C13.8603 6.07902 14.0511 6 14.25 6H15.75C15.9489 6 16.1397 6.07902 16.2803 6.21967C16.421 6.36032 16.5 6.55109 16.5 6.75V17.25C16.5 17.4489 16.421 17.6397 16.2803 17.7803C16.1397 17.921 15.9489 18 15.75 18H14.25C14.0511 18 13.8603 17.921 13.7197 17.7803C13.579 17.6397 13.5 17.4489 13.5 17.25V6.75ZM18 6.75C18 6.55109 18.079 6.36032 18.2197 6.21967C18.3603 6.07902 18.5511 6 18.75 6C18.9489 6 19.1397 6.07902 19.2803 6.21967C19.421 6.36032 19.5 6.55109 19.5 6.75V17.25C19.5 17.4489 19.421 17.6397 19.2803 17.7803C19.1397 17.921 18.9489 18 18.75 18C18.5511 18 18.3603 17.921 18.2197 17.7803C18.079 17.6397 18 17.4489 18 17.25V6.75Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="d-flex flex-column">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              class="m-auto"
            >
              <path
                d="M3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22ZM18 9H6V7H18V9ZM18 13H6V11H18V13ZM18 17H6V15H18V17Z"
                fill="#6F7287"
              />
            </svg>
            <p class="f-Overpass f-12 f-w-400">Riwayat</p>
          </div>
          <div class="d-flex flex-column">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              class="m-auto"
            >
              <path
                d="M11.9998 2.00012C6.47565 2.00012 1.99985 6.47593 1.99985 12.0001C1.99985 17.5243 6.47565 22.0001 11.9998 22.0001C17.524 22.0001 21.9998 17.5243 21.9998 12.0001C21.9998 6.47593 17.524 2.00012 11.9998 2.00012ZM11.9998 5.87109C13.9595 5.87109 15.5482 7.4598 15.5482 9.41948C15.5482 11.3792 13.9595 12.9679 11.9998 12.9679C10.0402 12.9679 8.45146 11.3792 8.45146 9.41948C8.45146 7.4598 10.0402 5.87109 11.9998 5.87109ZM11.9998 19.7421C9.63291 19.7421 7.51194 18.6695 6.09259 16.9921C6.85065 15.5646 8.33453 14.5808 10.0644 14.5808C10.1611 14.5808 10.2579 14.5969 10.3507 14.6251C10.8748 14.7945 11.4232 14.9033 11.9998 14.9033C12.5765 14.9033 13.1289 14.7945 13.649 14.6251C13.7418 14.5969 13.8386 14.5808 13.9353 14.5808C15.6652 14.5808 17.149 15.5646 17.9071 16.9921C16.4878 18.6695 14.3668 19.7421 11.9998 19.7421Z"
                fill="#6F7287"
              />
            </svg>
            <p class="f-Overpass f-12 f-w-400">Akun</p>
          </div>
        </div>
      </template>
      <template v-slot:modal>
        <modalContoh ref="modalContoh" />
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import modalContoh from "../components/modal/modalContoh.vue";
import { mapState, mapActions } from "vuex";
import VueJwtDecode from "vue-jwt-decode";

export default {
  name: "halaman-1",
  components: {
    slotBase,
    titleBar,
    modalContoh,
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState("playground", {
      dataDashboard: "dataDashboard",
      dataLayanan: "dataLayanan",
    }),

    // ubahNama() {
    //   this.nama = "rifki";
    // },
  },

  async mounted() {
    // console.log(process.env.VUE_APP_API_URL);
    const tokenData = VueJwtDecode.decode(localStorage.getItem("token"));
    // console.log(tokenData.id_customer_global);
    let tokenDataFix = tokenData.id_customer_global;
    await this.getDataLayanan(tokenDataFix).then((res) => {
      this.$toast.success(res.data.data.customer_global.id, {
        position: "top",
      });
    });
  },
  methods: {
    ...mapActions({
      getDataDashboard: "playground/getDataDashboard",
      getDataLayanan: "playground/getDataLayanan",
    }),

    pindah() {
      this.$router.push({ name: "halaman2" });
    },
    back() {
      this.getStateNama = "rifki";
    },
    modalOpen() {
      // console.log("open");
      this.$refs.modalContoh.open();
    },
    ubahstate() {
      // this.$store.commit("ubahNama", "rizal ardionto");
      this.getApiExample();
    },
  },
};
</script>
